import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { RequestOptionsArgs, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/retry';


@Injectable()
export class AuthHttpWithRetry {

  private DEFAULT_TOTAL_NUM_ATTEMPTS = 3;
  private DEFAULT_RETRY_DELAY_MILLIS = 1000;

  constructor(
    private authHttp: AuthHttp
  ) {}

  private retry(source: Observable<Response>, numAttempts, retryDelayInMillis): Observable<Response> {
      return (numAttempts > 1) ? source.retry(numAttempts - 1).delay(retryDelayInMillis) : source;
  }

  post(url: string, body: any, options?: RequestOptionsArgs,
    numAttempts = this.DEFAULT_TOTAL_NUM_ATTEMPTS, retryDelayInMillis = this.DEFAULT_RETRY_DELAY_MILLIS): Observable<Response> {
      return this.retry(this.authHttp.post(url, body, options), numAttempts, retryDelayInMillis);
  }

}



// WEBPACK FOOTER //
// ./app/services/http/auth-http-with-retry.ts